import axios from 'axios';

const state = {
    group_greeter: "",
};

const getters = {

};

const actions = {
    group_greeter_detail({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.get('/group-greeter/' + data)
            .then(response => {
                commit("PUSH_GROUP_GREETER", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    group_greeter_list({ commit }, data) {
        return new Promise((resolve, reject) => { 
            axios.get('/group-greeter', { params: data })
            .then(response => {
                commit("PUSH_GROUP_GREETER", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    group_greeter_create({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.post('/group-greeter', data)
            .then(response => {
                commit("PUSH_GROUP_GREETER", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    group_greeter_update({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.put('/group-greeter/' + data.id, data)
            .then(response => {
                commit("PUSH_GROUP_GREETER", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    delete_group_greeter({ commit }, data) {
        return new Promise((resolve, reject) => {
            axios.delete('/group-greeter/' + data)
            .then(response => {
                commit("DELETE_GROUP_GREETER", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
        })
    }
    
}

const mutations = {
    PUSH_GROUP_GREETER(state, data){
        state.group_greeter = data
    },
    DELETE_GROUP_GREETER(state, data){
        state.group_greeter = data
    },
};


export default {
  state,
  getters,
  actions,
  mutations
};
